import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref, computed } from "vue";
import { route } from "ziggy-js";
import { formatCurrency, formatShortDate } from "@js/utilities/formatters";
import { ArrowRight, X, ChevronDown, ChevronRight } from "lucide-vue-next";
import { getOverdueInvoiceGroups } from "@js/api/domain/invoice";
import InvoiceOrders from "@js/vue/domain/invoice/components/shared/InvoiceOrders.vue";
import OrderToggleButton from "@js/vue/domain/invoice/components/shared/OrderToggleButton.vue";
import CollapsibleCard from "@js/vue/components/ui/CollapsibleCard.vue";
import InvoiceExportButton from "@js/vue/domain/invoice/components/shared/InvoiceExportButton.vue";
import { useUserStore } from "@js/vue/domain/user/stores/useUserStore";
import LoadingSpinner from "@js/vue/components/ui/LoadingSpinner.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ClientMangerCard',
    setup(__props, { expose: __expose }) {
        __expose();
        const overdueInvoiceGroups = ref([]);
        const isLoading = ref(true);
        const error = ref('');
        const expandedRows = ref(new Set());
        const expandedBrands = ref(new Set());
        const userStore = useUserStore();
        const toggleShowOrders = (qbiID) => {
            if (expandedRows.value.has(qbiID)) {
                expandedRows.value.delete(qbiID);
            }
            else {
                expandedRows.value.add(qbiID);
            }
        };
        const toggleShowBrand = (brandId) => {
            if (expandedBrands.value.has(brandId)) {
                expandedBrands.value.delete(brandId);
            }
            else {
                expandedBrands.value.add(brandId);
            }
        };
        const fetchInvoiceGroups = async () => {
            try {
                isLoading.value = true;
                error.value = '';
                const response = await getOverdueInvoiceGroups();
                overdueInvoiceGroups.value = response.data;
            }
            catch (err) {
                error.value = 'Failed to load invoices';
            }
            finally {
                isLoading.value = false;
            }
        };
        const overdueInvoiceCount = computed(() => {
            return overdueInvoiceGroups.value.reduce((total, group) => {
                return total + (group.invoices?.length || 0);
            }, 0);
        });
        const exportFilters = computed(() => ({
            graphic_artist_id: userStore?.profile?.id,
            statuses: ['overdue'],
            per_page: 10000,
        }));
        onMounted(() => {
            fetchInvoiceGroups();
        });
        const __returned__ = { overdueInvoiceGroups, isLoading, error, expandedRows, expandedBrands, userStore, toggleShowOrders, toggleShowBrand, fetchInvoiceGroups, overdueInvoiceCount, exportFilters, get route() { return route; }, get formatCurrency() { return formatCurrency; }, get formatShortDate() { return formatShortDate; }, get ArrowRight() { return ArrowRight; }, get X() { return X; }, get ChevronDown() { return ChevronDown; }, get ChevronRight() { return ChevronRight; }, InvoiceOrders, OrderToggleButton, CollapsibleCard, InvoiceExportButton, LoadingSpinner };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
